import Select from 'react-tailwindcss-select'
import { Input } from '@material-tailwind/react'
import { usePage } from '@inertiajs/react'

import LoadingButton from '@/Shared/LoadingButton'

export default function({
                            handleSubmit,
                            hospitals,
                            errors,
                            data,
                            setData,
                            processing,
                            isEdit
                        }) {
    return (
        <form name="createForm" onSubmit={handleSubmit} className="mt-8">

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                {typeof hospitals === 'object' && (
                    <Select
                        label="Select Hospital"
                        name="hospital_id"
                        error={errors.hospital_id}
                        primaryColor="indigo"
                        value={
                            data.hospital_id && {
                                value: data.hospital_id,
                                label: hospitals.find(
                                    hospital => hospital.id === data.hospital_id
                                ).name
                            }
                        }
                        isSearchable
                        options={hospitals.map(hospital => ({
                            label: hospital.name,
                            value: hospital.id
                        }))}
                        onChange={option => setData('hospital_id', option.value)}
                    />
                )}

                <Input
                    size="lg"
                    label="Beds"
                    name="beds"
                    type="number"
                    error={errors.beds}
                    value={data.beds}
                    onChange={e => setData('beds', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Package Name"
                    name="package"
                    error={errors.package}
                    value={data.package}
                    onChange={e => setData('package', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Firm"
                    name="firm"
                    error={errors.firm}
                    value={data.firm}
                    onChange={e => setData('firm', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="HR to be deployed per day per Hospital"
                    name="per_day"
                    error={errors.per_day}
                    value={data.per_day}
                    onChange={e => setData('per_day', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Total HR required including relievers per Hospital"
                    name="total_required"
                    error={errors.total_required}
                    value={data.total_required}
                    onChange={e => setData('total_required', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Supervisor"
                    name="supervisor"
                    type="number"
                    error={errors.supervisor}
                    value={data.supervisor}
                    onChange={e => setData('supervisor', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Janitors"
                    name="janitors"
                    type="number"
                    error={errors.janitors}
                    value={data.janitors}
                    onChange={e => setData('janitors', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Sewer Men"
                    name="sewer_men"
                    type="number"
                    error={errors.sewer_men}
                    value={data.sewer_men}
                    onChange={e => setData('sewer_men', e.target.value)}
                />
            </div>

            <div className="mt-8 flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4">
                <LoadingButton
                    loading={processing}
                    type="submit"
                    className="btn-indigo"
                >
                    {isEdit ? 'Update' : 'Add'} HR
                </LoadingButton>
            </div>
        </form>
    )
}
